eventHub = require '../event_hub.coffee'

module.exports =
  template: """
    <tr class="form-field" :class="classList">
      <td>
        <div class="ui field">
          <input  v-model="item.name"
            :name="'project_clearance[' + attr_name + '][' + _uid + '][name]'"
             placeholder="Name"
            class="item-item_no">
        </div>
      </td>

      <td colspan='8'>
        <div class="ui field">
          <input v-model="item.job"
            :name="'project_clearance[' + attr_name + '][' + _uid + '][job]'"
             placeholder="Job"
            class="font-weight-500 fs-5 item-job">
        </div>
      </td>

      <td>
        <div class="text-left">
          <a class="ui basic icon button" @click="removeItem(index)">
            <i class="icon trash"></i>
          </a>
        </div>
      </td>
    </tr>

  """
  props: ['item', 'index', 'attr_name']
#  data: ->
#    logo: null


  renderError: (h, err)->
    greenPOS.notify_error "Error Rendering Page!"


  methods:
    removeItem: (index)->
      eventHub.$emit('remove-employee', { index: index, type: @attr_name })


  computed:
    isValid: ->
      true

    classList: ->
      list = {}
      list['error']         = not @isValid
      list["item-#{@_uid}"] = true
      list

